export default "__VITE_ASSET__DAl6yzFR__"